import { FunctionalComponent, cloneElement, createRef, h, isValidElement, toChildArray } from 'preact';

import { FadingContainer } from '../MainLayout/MainLayout.styles';
import { LAYER_PLACEMENT } from '../../enums';
import { SCROLL_CONTAINER_ID } from '../../constants';
import { media } from '../../styles';
import styled from 'styled-components';
import { useDeviceState } from '../../hooks';

type Props = {
  ariaLabel?: string;
  layerPlacement: LAYER_PLACEMENT | null;
  minHeight?: number;
  useBackgroundColor: boolean;
  withFadingTop?: boolean;
  withFadingBottom?: boolean;
  useColor?: boolean;
  isMobile?: boolean;
};

const VerticalScrollerWrapper = styled.div<Props>`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
  z-index: 1;
  max-height: ${({ layerPlacement, isMobile }) =>
    layerPlacement === LAYER_PLACEMENT.SIDE || isMobile ? 'initial' : '65vh'};
  ${({ theme, useBackgroundColor }) =>
    useBackgroundColor
      ? `background-color: ${theme.ui.layer.backgroundColor}`
      : `background-color: ${theme.ui.secondLayer.content.backgroundColor}`};
  ${media.ie11} {
    overflow: auto;
    min-height: ${({ minHeight }) => (minHeight ? `${minHeight}px` : '80px')};
  }
  ${media.mobileLandscape || media.mobilePortrait || media.mobilePortraitXS} {
    ${({ useColor, theme }) => useColor && `color: ${theme.ui.text.color}`};
  }
`;

const VerticalScroller: FunctionalComponent<Props> = ({
  ariaLabel,
  children,
  layerPlacement,
  minHeight,
  useBackgroundColor = false,
  useColor = false,
}) => {
  const ref = createRef();
  const { isDesktop } = useDeviceState();

  const childrenWithProps = toChildArray(children).map((child) => {
    if (isValidElement(child)) {
      return cloneElement(child, { scrollerRef: ref });
    }

    return child;
  });

  return (
    <VerticalScrollerWrapper
      ref={ref}
      aria-label={ariaLabel}
      data-testid={SCROLL_CONTAINER_ID}
      layerPlacement={layerPlacement}
      minHeight={minHeight}
      useBackgroundColor={useBackgroundColor}
      useColor={useColor}
      isMobile={!isDesktop}
    >
      <FadingContainer useBackgroundColor={useBackgroundColor}>{childrenWithProps}</FadingContainer>
    </VerticalScrollerWrapper>
  );
};

export default VerticalScroller;
